module.exports = __webpack_public_path__ + "static/archive-e9527bfe12e5fb75c92de72c325312d8.png";